import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

const CustomProductAddToCartModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/CustomProductAddToCartModal.vue');

export default {
  name: 'TheCartSection',
  components: {
    CustomProductAddToCartModal
  },
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showModal: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread({}, mapActions({
    addCart: 'cart/add'
  }), {
    openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'LayerAddToCart',
        products: this.products
      });
      return false;
    },

    addToCart() {
      var _this = this;

      return _asyncToGenerator(function* () {
        try {
          _this.openLayer();

          if (_this.products[0]) {
            yield _this.addCart({
              reference: _this.products[0].reference,
              referenceEncoded: btoa(_this.products[0].reference),
              quantity: 1
            });
          }

          if (_this.products[1]) {
            yield _this.addCart({
              reference: _this.products[1].reference,
              referenceEncoded: btoa(_this.products[1].reference),
              quantity: 1
            });
          }
        } catch (err) {
          console.log(err);
        }
      })();
    },

    closeAction() {
      this.showModal = false;
    }

  })
};